// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.src-business-attribute-AttributesTransfer-AttributesTransfer-module__frame--pYYYT {
  display: flex;
  gap: 8px;
  height: 100%;
  overflow: hidden;
  align-items: center;
}
.src-business-attribute-AttributesTransfer-AttributesTransfer-module__part--KNyvJ {
  height: 100%;
  overflow: hidden;
  flex: 1;
  border-radius: 2px;
  border: 1px solid #d9d9d9;
}
.src-business-attribute-AttributesTransfer-AttributesTransfer-module__middle--mHgHM {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
/*# sourceMappingURL=AttributesTransfer.module.css.map */`, "",{"version":3,"sources":["webpack://./AttributesTransfer.module.less","webpack://./src/business/attribute/AttributesTransfer/AttributesTransfer.module.less"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,QAAA;EACA,YAAA;EACA,gBAAA;EACA,mBAAA;ACCF;ADEA;EACE,YAAA;EACA,gBAAA;EACA,OAAA;EACA,kBAAA;EACA,yBAAA;ACAF;ADGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;ACDF;AACA,wDAAwD","sourcesContent":[".frame {\n  display: flex;\n  gap: 8px;\n  height: 100%;\n  overflow: hidden;\n  align-items: center;\n}\n\n.part {\n  height: 100%;\n  overflow: hidden;\n  flex: 1;\n  border-radius: 2px;\n  border: 1px solid #d9d9d9;\n}\n\n.middle {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n",".frame {\n  display: flex;\n  gap: 8px;\n  height: 100%;\n  overflow: hidden;\n  align-items: center;\n}\n.part {\n  height: 100%;\n  overflow: hidden;\n  flex: 1;\n  border-radius: 2px;\n  border: 1px solid #d9d9d9;\n}\n.middle {\n  display: flex;\n  flex-direction: column;\n  gap: 4px;\n}\n/*# sourceMappingURL=AttributesTransfer.module.css.map */"],"sourceRoot":""}]);
// Exports
export var frame = `src-business-attribute-AttributesTransfer-AttributesTransfer-module__frame--pYYYT`;
export var part = `src-business-attribute-AttributesTransfer-AttributesTransfer-module__part--KNyvJ`;
export var middle = `src-business-attribute-AttributesTransfer-AttributesTransfer-module__middle--mHgHM`;
export default ___CSS_LOADER_EXPORT___;
